import React, { useState, useEffect, useCallback } from "react";
import { Col, Row, Image, Form } from "react-bootstrap";
import { ChartsComponent } from "../../../reusableComponent";

// charts constants

import { FIRST_PIE_CHART_DASHBOARD_HELPER } from "./pie.first.dashboard";
import { FIRST_PIE_CHART_RESPONSIVE_HELPER } from "./pie.first.responsive";
import { SECOND_PIE_CHART_DASHBOARD_HELPER } from "./pie.second.dashboard";
import { SECOND_PIE_CHART_RESPONSIVE_HELPER } from "./pie.second.responsive";
import { SECOND_PIE_CHART_HELPER } from "../secondPage/pie.second";
import { FIRST_GRAPH_CHART_HELPER } from "../secondPage/graph.third";
import { FIRST_PIE_CHART_HELPER } from "../secondPage/pie.first";
import { FIRST_PIE_CHART_DASHBOARD_HELPER as FIRST_PIE_CHART_DASHBOARD_HELPER_SECOND_PAGE } from "../secondPage/pie.first.dashboard";
import { FIRST_PIE_CHART_RESPONSIVE_HELPER as FIRST_PIE_CHART_RESPONSIVE_HELPER_SECOND_PAGE } from "../secondPage/pie.first.responsive";

// actions
import {
  getUnderImplementationProjectsByAction,
  getProjectsByCompletionStageAction,
  getProjectCostOverRunAction,
  getProjectDelayedAction,
  getProjectStageWisePendingIssuesAction,
  getProjectStageWisePendingIssuesWithRecipientAction,
  getAverageBucketWiseDelayAction,
  getProjectsByImplementationModeAction
} from "../../../../actions/reports.action";

// helper
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { THIRD_PIE_CHART_DASHBOARD_HELPER } from "./pie.third.dashboard";
import { COSTOVERRUN_PIE_CHART_RESPONSIVE_HELPER } from "./pie.costOverrun.responsive";
import { COSTOVERRUN_PIE_CHART_DASHBOARD_HELPER } from "./pie.costOverrun.dashboard";
import { DELAYED_PIE_CHART_RESPONSIVE_HELPER } from "./pie.delayed.responsive";
import { DELAYED_PIE_CHART_DASHBOARD_HELPER } from "./pie.delayed.dashboard";
import { THIRD_PIE_CHART_RESPONSIVE_HELPER } from "./pie.third.responsive";
import { PROJECT_STAGE_WISE_DASHBOARD_CHART_HELPER } from "./bar.stageWise.dashboard";
import { CUMULATIVE_AVERAGE_DELAY_DASHBOARD_CHART_HELPER } from "./bar.averageDelay.dashboard";
import { PATHS, STATUS } from "../../../../constant";
import TableLoaderTemplate from "../../../../component/TableLoaderTemplate";
import { IssuePendingLoader } from "../../../../component/LoadersTemplate";
import { isValidArray, sortBy, getLocalstorage } from "../../../../helper";
import NoDataFound from "../../../../component/NoDataFound";
import { get } from "lodash";
import MeetingTable from "./meetingTable";
import DisplayByPermission from "../../../../component/DisplayByPermission";
import { UploadCSVComponent } from "../../../../component/UploadCSVFile";
import { PROJECT_STAGE_WISE_PENDING_ISSUES_DASHBOARD_CHART_HELPER } from "./stackedBar.pendingIssues.dashboard";
import { PROJECT_STAGE_WISE_RESPONSIVE_CHART_HELPER } from "./bar.stageWise.responsive";
import { PROJECT_STAGE_WISE_PENDING_ISSUES_RESPONSIVE_CHART_HELPER } from "./stackedBar.pendingIssues.responsive";
import { CUMULATIVE_AVERAGE_DELAY_RESPONSIVE_CHART_HELPER } from "./bar.averageDelay.responsive";
import CustomDropdown from "../../../reusableComponent/Dropdown/CustomDropdown";

const FourthPage = React.memo(function FourthPage({
  displayOnDashboard = false,
  dashboardClass,
  isDesktopView,
  issuesByCategoryDataStatus,
  issuesByCategoryData,
  getPmgMeetingData,
  getPmgMeetingStatus,
  getProjectStagesForGraphsStatus,
  getProjectStagesForGraphsData,
  permission,
  uploadMeetingCSV,
  getMeetingTableData,
  meetingTableData,
  meetingTableStatus,
  history,
  checkedValue,
  user
}) {
  const [
    underImplementationProjects,
    setUnderImplementationProjects
  ] = useState({
    isLoading: false,
    pieData: [],
    graphData: []
  });
  const [projectStage, setProjectStage] = useState({
    isLoading: false,
    data: []
  });
  const [projectCostOverrun, setProjectCostOverrun] = useState({
    isLoading: false,
    data: []
  });
  const [projectDelayed, setProjectDelayed] = useState({
    isLoading: false,
    data: []
  });
  const [pendingIssues, setPendingIssues] = useState({
    isLoading: false,
    data: [],
    selectedStateWiseData: {}
  });
  const [averageDelays, setAverageDelays] = useState({
    isLoading: false,
    data: [],
    selectedGroup: {}
  });
  const [pendingIssuesWithRecipient, setPendingIssuesWithRecipient] = useState({
    isLoading: false,
    data: []
  });
  const [projectImplementationMode, setProjectImplementationMode] = useState({
    isLoading: false,
    data: []
  });
  const [updateValue, setUpdateValue] = useState(0);

  useEffect(() => {
    //projectsByCompletionStageData();
    getUnderImplementationProjectsApisData();
    projectCostOverRunData();
    projectDelayedData();
    getProjectStageWisePendingIssues();
    getCumulativeAverageDelay();
    getIssuesPendingWithRecipientAcrossBucket();
    getProjectsByImplementationModeApisData();
  }, [checkedValue]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [updateValue]);

  const onScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (isDesktopView) {
      if (currentOffset === 100 || currentOffset === 300) {
        setUpdateValue(updateValue + 1);
      }
    }
    /*if (
            (currentOffset > 350 && currentOffset < 450) ||
            (currentOffset > 1050 && currentOffset < 1150)
        ) {
            setUpdateValue(updateValue + 1);
        }*/
  };

  /*   const projectsByCompletionStageData = async () => {
        // loading started
        setProjectStage({ isLoading: true, data: [] });
        // get data
        const projectStageResp = await getProjectsByCompletionStageAction();
        // loading completed
        setProjectStage({
            isLoading: false,
            data: isDesktopView
                    ? FIRST_PIE_CHART_DASHBOARD_HELPER(projectStageResp.data)
                    : FIRST_PIE_CHART_RESPONSIVE_HELPER(projectStageResp.data)
        });
    };*/

  const projectCostOverRunData = async () => {
    // loading started
    setProjectCostOverrun({ isLoading: true, data: [] });
    // get data
    const projectCostOverrunResp = await getProjectCostOverRunAction(
      undefined,
      checkedValue
    );
    // loading completed
    setProjectCostOverrun({
      isLoading: false,
      data: isDesktopView
        ? COSTOVERRUN_PIE_CHART_DASHBOARD_HELPER(
            projectCostOverrunResp.data,
            history,
            checkedValue,
            user
          )
        : COSTOVERRUN_PIE_CHART_RESPONSIVE_HELPER(
            projectCostOverrunResp.data,
            history,
            checkedValue,
            user
          )
    });
  };

  const projectDelayedData = async () => {
    // loading started
    setProjectDelayed({ isLoading: true, data: [] });
    // get data
    const projectDelayedResp = await getProjectDelayedAction(
      undefined,
      checkedValue
    );
    // loading completed
    setProjectDelayed({
      isLoading: false,
      data: isDesktopView
        ? DELAYED_PIE_CHART_DASHBOARD_HELPER(
            projectDelayedResp.data,
            history,
            checkedValue,
            user
          )
        : DELAYED_PIE_CHART_RESPONSIVE_HELPER(
            projectDelayedResp.data,
            history,
            checkedValue,
            user
          )
    });
  };

  const getUnderImplementationProjectsApisData = async () => {
    try {
      // loading started
      setUnderImplementationProjects({
        isLoading: true,
        pieData: [],
        graphData: []
      });
      // get data
      const issueReportResp = await getUnderImplementationProjectsByAction(
        undefined,
        checkedValue
      );
      // loading completed
      setUnderImplementationProjects({
        isLoading: false,
        pieData: displayOnDashboard
          ? isDesktopView
            ? SECOND_PIE_CHART_DASHBOARD_HELPER(
                issueReportResp.data,
                history,
                checkedValue,
                user
              ) || []
            : (issueReportResp.data, history) || []
          : SECOND_PIE_CHART_HELPER(issueReportResp.data) || [],
        graphData: FIRST_GRAPH_CHART_HELPER(issueReportResp.data) || []
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getProjectStageWisePendingIssues = async () => {
    // loading started
    setPendingIssues({ isLoading: true, data: [], selectedStateWiseData: {} });
    // get data
    const stateWiseResp = await getProjectStageWisePendingIssuesAction(
      undefined,
      checkedValue
    );
    // loading completed
    if (isValidArray(get(stateWiseResp, "data", []))) {
      let index_All = get(stateWiseResp, "data", []).findIndex(
        chart => chart.groupName === "All"
      );
      let deleted_Item = get(stateWiseResp, "data", []).splice(index_All);
      get(stateWiseResp, "data", []).unshift(...deleted_Item);

      let firstStateWiseItem =
        (isValidArray(get(stateWiseResp, "data", [])) &&
          get(stateWiseResp, "data", [])[0]) ||
        {};

      setPendingIssues({
        isLoading: false,
        data: get(stateWiseResp, "data", []),
        selectedStateWiseData: firstStateWiseItem
      });
    }
  };

  const getCumulativeAverageDelay = async () => {
    // loading started
    setAverageDelays({ isLoading: true, data: [], selectedGroup: {} });
    // get data
    const averageDelayResp = await getAverageBucketWiseDelayAction(
      undefined,
      checkedValue
    );
    // loading completed
    if (isValidArray(get(averageDelayResp, "data", []))) {
      let index_All = get(averageDelayResp, "data", []).findIndex(
        chart => chart.group.name === "All"
      );
      let deleted_Item = get(averageDelayResp, "data", []).splice(index_All);
      get(averageDelayResp, "data", []).unshift(...deleted_Item);

      let firstStateWiseItem =
        (isValidArray(get(averageDelayResp, "data", [])) &&
          get(averageDelayResp, "data", [])[0]) ||
        {};

      setAverageDelays({
        isLoading: false,
        data: get(averageDelayResp, "data", []),
        selectedGroup: firstStateWiseItem
      });
    }
  };

  const getIssuesPendingWithRecipientAcrossBucket = async () => {
    // loading started
    setPendingIssuesWithRecipient({ isLoading: true, data: [] });
    // get data
    const stateWiseResp = await getProjectStageWisePendingIssuesWithRecipientAction(
      undefined,
      checkedValue
    );
    // loading completed
    setPendingIssuesWithRecipient({
      isLoading: false,
      data: stateWiseResp.data || []
    });
  };

  const getProjectsByImplementationModeApisData = async () => {
    // loading started
    setProjectImplementationMode({ isLoading: true, data: [] });
    // get data
    const resp = await getProjectsByImplementationModeAction(
      undefined,
      checkedValue
    );
    // loading completed
    setProjectImplementationMode({
      isLoading: false,
      data: displayOnDashboard
        ? isDesktopView
          ? FIRST_PIE_CHART_DASHBOARD_HELPER_SECOND_PAGE(
              resp.data,
              history,
              checkedValue
            )
          : FIRST_PIE_CHART_RESPONSIVE_HELPER_SECOND_PAGE(
              resp.data,
              history,
              checkedValue
            )
        : FIRST_PIE_CHART_HELPER(resp.data)
    });
  };

  const onChartFilter = (filterValue, key) => {
    if (key === "stage_wise") {
      let selectFilterValue = pendingIssues.data.find(
        item => item.groupName === filterValue
      );
      setPendingIssues({
        isLoading: pendingIssues.isLoading,
        data: pendingIssues.data,
        selectedStateWiseData: selectFilterValue
      });
    }

    if (key === "average_delay") {
      let selectFilterValue = averageDelays.data.find(
        item => item.group.name === filterValue
      );
      setAverageDelays({
        isLoading: averageDelays.isLoading,
        data: averageDelays.data,
        selectedGroup: selectFilterValue
      });
    }
  };

  const userGroupCategory = get(user, "groupCategory") === "PMG";
  const ministryGroupCategory = get(user, "groupCategory") === "CENTRAL";
  // Apply new chart order only for PMG and Ministry dashboard users.
  const showReorderedDashboardCharts =
    userGroupCategory || ministryGroupCategory;

  // Average Delay Graph Value for Central user (Non-PMG)
  const averageDelay = get(averageDelays, "data").find(
    item => item.group.name === user.groupName
  );

  // Pending Value Graph Value for Central user (Non-PMG)
  const pendingIssuesValue = get(pendingIssues, "data").find(
    item => item.groupName === user.groupName
  );

  let settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  let groupCategory = getLocalstorage("groupCategory");
  // let user = getLocalstorage("user");

  return (
    <>
      {/* PDF First Section Start */}
      {!isDesktopView && displayOnDashboard ? (
        <Slider {...settings}>
          {
            <DisplayByPermission
              display={get(permission, "readProjectStatusPieChart")}
            >
              <ChartsComponent
                isLoading={getProjectStagesForGraphsStatus === "LOADING"}
                chartConfig={FIRST_PIE_CHART_RESPONSIVE_HELPER(
                  getProjectStagesForGraphsData,
                  history
                )}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Projects Status"
                updateValue={updateValue}
              />
            </DisplayByPermission>
          }
          {
            <DisplayByPermission
              display={get(
                permission,
                "readSectorWiseUnderImplementationProjectPieChart"
              )}
            >
              <ChartsComponent
                isLoading={underImplementationProjects.isLoading}
                chartConfig={underImplementationProjects.pieData}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Sector-wise Distribution of Under Implementation Projects"
                updateValue={updateValue}
              />
            </DisplayByPermission>
          }
          {
            <DisplayByPermission
              display={get(permission, "readUnderImplementDelayReport")}
            >
              <ChartsComponent
                isLoading={projectDelayed.isLoading}
                chartConfig={projectDelayed.data}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Time Over-run (years) in Under Implementation Projects"
                updateValue={updateValue}
              />
            </DisplayByPermission>
          }
          {
            <DisplayByPermission
              display={get(permission, "readUnderImplementCostOverRunReport")}
            >
              <ChartsComponent
                isLoading={projectCostOverrun.isLoading}
                chartConfig={projectCostOverrun.data}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Cost Over-run (%) in Under Implementation Projects"
                updateValue={updateValue}
              />
            </DisplayByPermission>
          }
          {/* For PMG/Ministry: show Implementation Mode instead of Types of Pending Issues here. */}
          {showReorderedDashboardCharts ? (
            <div>
              <ChartsComponent
                isLoading={projectImplementationMode.isLoading}
                chartConfig={projectImplementationMode.data}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Implementation Mode in Under Implementation Projects"
                updateValue={updateValue}
              />
              <section id="second-page-pie-labels-1" />
            </div>
          ) : (
            <DisplayByPermission
              display={get(permission, "readPendingIssuePieChart")}
            >
              <ChartsComponent
                isLoading={
                  !(issuesByCategoryData && issuesByCategoryData.length)
                }
                chartConfig={THIRD_PIE_CHART_RESPONSIVE_HELPER(
                  issuesByCategoryData,
                  history
                )}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Types of Pending Issues"
                updateValue={updateValue}
              />
            </DisplayByPermission>
          )}
          {
            <DisplayByPermission
              display={get(permission, "readProjectStageWisePendingIssues")}
            >
              <ChartsComponent
                isLoading={pendingIssues.isLoading}
                chartConfig={PROJECT_STAGE_WISE_RESPONSIVE_CHART_HELPER(
                  pendingIssues.selectedStateWiseData
                )}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Project Stage-Wise Pending Issues"
                // extraTopSpace={true}
                updateValue={updateValue}
              />
              <Form className="project-by-filters">
                <Form.Group className="field-select">
                  <Form.Control
                    value={pendingIssues.selectedStateWiseData.groupName}
                    as="select"
                    onChange={e => onChartFilter(e.target.value, "stage_wise")}
                    name="delayedProjectModeSelect"
                  >
                    {get(pendingIssues, "data", []).map(groups => (
                      <option value={get(groups, "groupName", "")}>
                        {get(groups, "groupName", "")}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            </DisplayByPermission>
          }
          {/* For PMG/Ministry: hide Average Delay from this place. */}
          {!showReorderedDashboardCharts ? (
            <DisplayByPermission
              display={get(permission, "averageBucketWiseDelay")}
            >
              <ChartsComponent
                isLoading={pendingIssues.isLoading}
                chartConfig={CUMULATIVE_AVERAGE_DELAY_RESPONSIVE_CHART_HELPER(
                  get(averageDelays, "selectedGroup", {})
                )}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Average delay (days) during Project Lifecycle from original finish date*"
                updateValue={updateValue}
              />
              <Form className="project-by-filters">
                <Form.Group className="field-select">
                  <Form.Control
                    value={get(averageDelays, "selectedGroup.group.name", "")}
                    as="select"
                    onChange={e =>
                      onChartFilter(e.target.value, "average_delay")
                    }
                    name="delayedProjectModeSelect"
                  >
                    {get(averageDelays, "data", []).map(groups => (
                      <option value={get(groups, "group.name", "")}>
                        {get(groups, "group.name", "")}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            </DisplayByPermission>
          ) : null}
          {
            <DisplayByPermission
              display={get(
                permission,
                "readIssuesPendingWithRecipientAcrossBucket"
              )}
            >
              <ChartsComponent
                isLoading={pendingIssuesWithRecipient.isLoading}
                chartConfig={PROJECT_STAGE_WISE_PENDING_ISSUES_RESPONSIVE_CHART_HELPER(
                  pendingIssuesWithRecipient.data
                )}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Issues Pending with Recipient across Project Stages"
                updateValue={updateValue}
              />
              <section id="second-page-pie-labels-1" />
            </DisplayByPermission>
          }
          {/* For PMG/Ministry: show Types of Pending Issues in the right-side place. */}
          {showReorderedDashboardCharts ? (
            <DisplayByPermission
              display={get(permission, "readPendingIssuePieChart")}
            >
              <ChartsComponent
                isLoading={
                  !(issuesByCategoryData && issuesByCategoryData.length)
                }
                chartConfig={THIRD_PIE_CHART_RESPONSIVE_HELPER(
                  issuesByCategoryData,
                  history
                )}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Types of Pending Issues"
                updateValue={updateValue}
              />
            </DisplayByPermission>
          ) : null}
        </Slider>
      ) : (
        <div className={`charts-sections first-section ${dashboardClass}`}>
          <div className="chart">
            {/* Section */}
            {/* Dashboard Project Status Chart */}
            <DisplayByPermission
              display={get(permission, "readProjectStatusPieChart")}
            >
              <div className="charts-sections-left even">
                <ChartsComponent
                  isLoading={getProjectStagesForGraphsStatus === "LOADING"}
                  chartConfig={FIRST_PIE_CHART_DASHBOARD_HELPER(
                    getProjectStagesForGraphsData,
                    history,
                    checkedValue,
                    user
                  )}
                  displayOnDashboard={displayOnDashboard}
                  displayTitle="Projects Status"
                  updateValue={updateValue}
                />
                <section id="second-page-pie-labels-1" />
              </div>
            </DisplayByPermission>

            {/* Right Section */}
            <DisplayByPermission
              display={get(
                permission,
                "readSectorWiseUnderImplementationProjectPieChart"
              )}
            >
              <div className={`charts-sections-right odd ${dashboardClass}`}>
                <ChartsComponent
                  isLoading={underImplementationProjects.isLoading}
                  chartConfig={underImplementationProjects.pieData}
                  displayOnDashboard={displayOnDashboard}
                  displayTitle="Sector-wise Distribution of Under Implementation Projects"
                  updateValue={updateValue}
                />
                <section id="second-page-pie-labels-2" />
              </div>
            </DisplayByPermission>
          </div>

          <div className="chart">
            {/* Section */}
            {
              <DisplayByPermission
                display={get(permission, "readUnderImplementDelayReport")}
              >
                <div className={`charts-sections-right odd ${dashboardClass}`}>
                  <ChartsComponent
                    isLoading={projectDelayed.isLoading}
                    chartConfig={projectDelayed.data}
                    displayOnDashboard={displayOnDashboard}
                    displayTitle="Time Over-run (years) in Under Implementation Projects"
                    updateValue={updateValue}
                  />
                  <section id="second-page-pie-labels-2" />
                </div>
              </DisplayByPermission>
            }

            {/* Right Section */}
            {
              <DisplayByPermission
                display={get(permission, "readUnderImplementCostOverRunReport")}
              >
                <div className={`charts-sections-right odd ${dashboardClass}`}>
                  <ChartsComponent
                    isLoading={projectCostOverrun.isLoading}
                    chartConfig={projectCostOverrun.data}
                    displayOnDashboard={displayOnDashboard}
                    displayTitle="Cost Over-run (%) in Under Implementation Projects"
                    updateValue={updateValue}
                  />
                  <section id="second-page-pie-labels-2" />
                </div>
              </DisplayByPermission>
            }
          </div>

          <div className="chart">
            {/* Section */}
            {// For PMG/Ministry: put Implementation Mode in the old Types chart place.
            showReorderedDashboardCharts ? (
              <div className="charts-sections-left even">
                <ChartsComponent
                  isLoading={projectImplementationMode.isLoading}
                  chartConfig={projectImplementationMode.data}
                  displayOnDashboard={displayOnDashboard}
                  displayTitle="Implementation Mode in Under Implementation Projects"
                  updateValue={updateValue}
                />
                <section id="second-page-pie-labels-1" />
              </div>
            ) : (
              <>
                <DisplayByPermission
                  display={get(permission, "readPendingIssuePieChart")}
                >
                  <div className="charts-sections-left even">
                    <ChartsComponent
                      // isLoading={
                      //   issuesByCategoryDataStatus === "LOADING" ||
                      //   !(issuesByCategoryData && issuesByCategoryData.length)
                      // }
                      chartConfig={THIRD_PIE_CHART_DASHBOARD_HELPER(
                        issuesByCategoryData,
                        history,
                        checkedValue,
                        user
                      )}
                      displayOnDashboard={displayOnDashboard}
                      displayTitle="Types of Pending Issues"
                      updateValue={updateValue}
                    />
                    <section id="second-page-pie-labels-1" />
                  </div>
                </DisplayByPermission>
                {groupCategory === "CENTRAL" ? (
                  <DisplayByPermission
                    display={get(
                      permission,
                      "readIssuesPendingWithRecipientAcrossBucket"
                    )}
                  >
                    <div className="charts-sections-left even">
                      <ChartsComponent
                        isLoading={pendingIssuesWithRecipient.isLoading}
                        chartConfig={PROJECT_STAGE_WISE_PENDING_ISSUES_DASHBOARD_CHART_HELPER(
                          pendingIssuesWithRecipient.data
                        )}
                        displayOnDashboard={displayOnDashboard}
                        displayTitle="Issues Pending with Recipient across Project Stages"
                        updateValue={updateValue}
                      />
                      <section id="second-page-pie-labels-1" />
                    </div>
                  </DisplayByPermission>
                ) : (
                  <></>
                )}
              </>
            )}

            {/* Right Section */}
            {/* For PMG/Ministry: move Types of Pending Issues to the right side. */}
            {showReorderedDashboardCharts ? (
              <DisplayByPermission
                display={get(permission, "readPendingIssuePieChart")}
              >
                <div className={`charts-sections-right odd ${dashboardClass}`}>
                  <ChartsComponent
                    chartConfig={THIRD_PIE_CHART_DASHBOARD_HELPER(
                      issuesByCategoryData,
                      history,
                      checkedValue,
                      user
                    )}
                    displayOnDashboard={displayOnDashboard}
                    displayTitle="Types of Pending Issues"
                    updateValue={updateValue}
                  />
                  <section id="second-page-pie-labels-1" />
                </div>
              </DisplayByPermission>
            ) : (
              <DisplayByPermission
                display={get(permission, "readMeetingChairedByStatusReport")}
              >
                <div
                  className={`charts-sections-right odd ${dashboardClass} meeting-status-box`}
                >
                  <div
                    /*className={`heading-for-charts ${
                              extraTopSpace ? "extra-top-space" : null
                              }`}*/
                    className={`heading-for-charts`}
                  >
                    <div>Meetings Status</div>
                    <div className="download-options">
                      <UploadCSVComponent
                        uploadMeetingCSV={uploadMeetingCSV}
                        callApiOnSuccess={getMeetingTableData}
                      />
                    </div>
                  </div>
                  {/* <MeetingTable
                    getPmgMeetingData={getPmgMeetingData}
                    getPmgMeetingStatus={getPmgMeetingStatus}
                  /> */}
                  <div className="meeting-status-wrapper">
                    <MeetingTable
                      meetingTableData={meetingTableData}
                      meetingTableStatus={meetingTableStatus}
                    />
                  </div>
                </div>
              </DisplayByPermission>
            )}
          </div>
          <div className="chart project-lifecycle">
            {/* Project Stage Wise Issues */}
            <DisplayByPermission
              display={get(permission, "readProjectStageWisePendingIssues")}
            >
              <div className="charts-sections-left even">
                <ChartsComponent
                  isLoading={pendingIssues.isLoading}
                  chartConfig={PROJECT_STAGE_WISE_DASHBOARD_CHART_HELPER(
                    userGroupCategory
                      ? pendingIssues.selectedStateWiseData
                      : pendingIssuesValue
                  )}
                  displayOnDashboard={displayOnDashboard}
                  displayTitle="Project Stage-Wise Pending Issues"
                  updateValue={updateValue}
                />
                {userGroupCategory &&
                  get(pendingIssues, "data", []).length > 0 && (
                    <Form className="project-by-filters">
                      <CustomDropdown
                        options={get(pendingIssues, "data", []).map(groups => ({
                          value: get(groups, "groupName", ""),
                          label: get(groups, "groupName", "")
                        }))}
                        onChange={onChartFilter}
                        width={"180px"}
                        height={"36px"}
                        className={"dashboard-big-dropdown"}
                        page={"dashboard-projectstagewise"}
                        menuClassName={"projectstagewiseMenu"}
                      />
                      {/* <Form.Group className="field-select">
                      <Form.Control
                        value={get(
                          pendingIssues,
                          "selectedStateWiseData.groupName",
                          ""
                        )}
                        as="select"
                        onChange={e =>
                          onChartFilter(e.target.value, "stage_wise")
                        }
                        name="delayedProjectModeSelect"
                      >
                        {get(pendingIssues, "data", []).map(groups => (
                          <option value={get(groups, "groupName", "")}>
                            {get(groups, "groupName", "")}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group> */}
                    </Form>
                  )}
              </div>
            </DisplayByPermission>

            {/* For PMG/Ministry: replace Average Delay with Issues Pending with Recipient. */}
            {showReorderedDashboardCharts ? (
              <DisplayByPermission
                display={get(
                  permission,
                  "readIssuesPendingWithRecipientAcrossBucket"
                )}
              >
                <div className="charts-sections-right odd">
                  <ChartsComponent
                    isLoading={pendingIssuesWithRecipient.isLoading}
                    chartConfig={PROJECT_STAGE_WISE_PENDING_ISSUES_DASHBOARD_CHART_HELPER(
                      pendingIssuesWithRecipient.data
                    )}
                    displayOnDashboard={displayOnDashboard}
                    displayTitle="Issues Pending with Recipient across Project Stages"
                    updateValue={updateValue}
                  />
                  <section id="second-page-pie-labels-1" />
                </div>
              </DisplayByPermission>
            ) : (
              <DisplayByPermission
                display={get(permission, "averageBucketWiseDelay")}
              >
                <div className="charts-sections-right odd">
                  <ChartsComponent
                    isLoading={pendingIssues.isLoading}
                    chartConfig={CUMULATIVE_AVERAGE_DELAY_DASHBOARD_CHART_HELPER(
                      averageDelay
                    )}
                    displayOnDashboard={displayOnDashboard}
                    displayTitle="Average delay (days) during Project Lifecycle from original finish date*"
                    updateValue={updateValue}
                    displayFooter={true}
                  />
                  {/* <Form.Group className="field-select">
                      <Form.Control
                        value={get(
                          averageDelays,
                          "selectedGroup.group.name",
                          ""
                        )}
                        as="select"
                        onChange={e =>
                          onChartFilter(e.target.value, "average_delay")
                        }
                        name="delayedProjectModeSelect"
                      >
                        {get(averageDelays, "data", []).map(groups => (
                          <option value={get(groups, "group.name", "")}>
                            {get(groups, "group.name", "")}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group> */}
                </div>
              </DisplayByPermission>
            )}
          </div>

          <div className="chart">
            {/* Old PMG row kept in code, but hidden because these charts are moved above. */}
            {!userGroupCategory && groupCategory === "PMG" ? (
              <>
                {/* Project Stage Wise Issues Pending With Recipient */}
                <DisplayByPermission
                  display={get(
                    permission,
                    "readIssuesPendingWithRecipientAcrossBucket"
                  )}
                >
                  <div className="charts-sections-left even">
                    <ChartsComponent
                      isLoading={pendingIssuesWithRecipient.isLoading}
                      chartConfig={PROJECT_STAGE_WISE_PENDING_ISSUES_DASHBOARD_CHART_HELPER(
                        pendingIssuesWithRecipient.data
                      )}
                      displayOnDashboard={displayOnDashboard}
                      displayTitle="Issues Pending with Recipient across Project Stages"
                      updateValue={updateValue}
                    />
                    <section id="second-page-pie-labels-1" />
                  </div>
                </DisplayByPermission>

                {/* Projects Under Construction */}

                <div className="charts-sections-right odd">
                  <ChartsComponent
                    isLoading={projectImplementationMode.isLoading}
                    chartConfig={projectImplementationMode.data}
                    displayOnDashboard={displayOnDashboard}
                    displayTitle="Implementation Mode in Under Implementation Projects"
                    updateValue={updateValue}
                  />
                  <section id="second-page-pie-labels-1" />
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
});

export { FourthPage };
